import API_URL from '../config';
import axios from 'axios';

import { getCookie } from './../utils/cookies';

export const getTimeLineDataApi = async(filtredOptions) => {
    try {
        const token = getCookie("T6hVzR7c0g3maM3F")
        const iv = getCookie("02hfCmUqpk66w4uG")
        const id = getCookie("3F2Mb2pJ1YRro5Z4")

        const option = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }

        const res = await axios.get(`${API_URL}/api/rapport/getTimeLineData/${id}/${iv}?opID=${filtredOptions.opID}&getFullYear=${filtredOptions.getFullYear}`, option);
        return res.data
    }
    catch (err) {
        throw err
    }
}

